export const TRUST_SIGNALS = [
  {
    id: "fatf",
    label: "FATF Aligned",
    short: "Recommendations 10–21 procedures",
    detail: "Our customer due diligence, record-keeping, and reporting procedures follow FATF Recommendations 10 through 21 — customer identification, beneficial ownership, ongoing monitoring, and suspicious-transaction escalation. Politically exposed persons face enhanced review and principal-level sign-off before any commercial step.",
  },
  {
    id: "oecd",
    label: "OECD DDG",
    short: "Five-step responsible sourcing framework",
    detail: "The OECD Due Diligence Guidance for Responsible Mineral Supply Chains structures every corridor review: establish management systems, identify and assess risk, design a mitigation strategy, independent third-party audit, and public reporting. Supply that cannot complete the five steps does not enter the network.",
  },
  {
    id: "kyc",
    label: "KYC / AML Verified",
    short: "Structured clearance before engagement",
    detail: "Every principal is identified to natural-person level: corporate registration, beneficial ownership mapping, authorized signatories, and verifiable banking. No commercial engagement begins — no terms, no allocations — until clearance completes.",
  },
  {
    id: "sanctions",
    label: "Sanctions Screened",
    short: "OFAC · EU · UN · UK HMT",
    detail: "All principals, beneficial owners, banking parties, and logistics providers are screened against OFAC, EU, UN, and UK HMT lists at onboarding and on a rolling basis thereafter. A screening hit suspends the engagement; a confirmed match ends it.",
  },
  {
    id: "dodd-frank",
    label: "Dodd-Frank §1502",
    short: "Conflict-mineral due diligence",
    detail: "Tin, tantalum, tungsten, and gold from conflict-affected regions carry Section 1502-aligned due diligence: smelter identification, chain-of-custody documentation, and cooperative-level verification in the DRC and Rwanda corridors.",
  },
  {
    id: "custody",
    label: "Chain of Custody",
    short: "Mine gate to final delivery",
    detail: "Every transfer of the metal is a matter of record: serialized lots, sealed transport, documented hand-offs, and vault receipts. A gap in custody invalidates the lot — it is re-verified or it leaves the network.",
  },
  {
    id: "instruments",
    label: "Trade Instruments",
    short: "SBLC · DLC · MT103 verified",
    detail: "Standby and documentary letters of credit and wire settlements are confirmed directly with issuing institutions before activation. Funds move against presented documents — never against promises.",
  },
  {
    id: "assay",
    label: "Independent Assay",
    short: "XRF on-site · fire assay at refinery",
    detail: "Handheld Olympus XRF screening at the point of origin, independent laboratory assay before export, and a final refinery assay at destination. The numbers on the last certificate are the numbers that settle.",
  },
];

export const STATUS_ITEMS = [
  { id: "screening", label: "Sanctions screening", state: "Active" },
  { id: "kyc", label: "KYC / AML protocol", state: "Enforced" },
  { id: "corridors", label: "Corridor review", state: "Current" },
  { id: "instruments", label: "Instrument verification", state: "Bank-direct" },
  { id: "audit", label: "Compliance audit cycle", state: "Q3 2026" },
];

export const RISK_QA = [
  {
    q: "How do I know the gold actually exists?",
    a: "Because it is weighed, scanned, and assayed by people who do not work for the seller. Every lot is screened by handheld XRF at origin, assayed by an independent laboratory before export, and re-assayed at the destination refinery. You receive the certificates, the serial numbers, and the custody record — and you can send your own inspector to witness any of it.",
  },
  {
    q: "What is a trial lift, and why does it protect me?",
    a: "A trial lift is a small first transaction — deliberately small. It proves the entire corridor end-to-end: documents, logistics, assay, settlement. If anything fails, it fails small, before serious capital is committed. Only after a clean trial does a program scale. Beware any counterparty who pushes for a large first transaction.",
  },
  {
    q: "Why does everyone talk about 'paper gold' being risky?",
    a: "A futures contract or unallocated account is a claim on gold, not gold itself. In normal times the difference feels academic; in stressed markets, claims queue up and physical metal commands a premium. Allocated, serialized metal in a recognized vault is yours regardless of what any intermediary's balance sheet does.",
  },
  {
    q: "What happens if a counterparty fails your screening?",
    a: "The engagement stops — politely, and completely. We do not negotiate around sanctions hits, unverifiable funds, or undocumented product, regardless of how attractive the commercial terms look. This protects every other participant in the network, including you.",
  },
  {
    q: "Why does all this documentation cost time and money?",
    a: "Because documentation is what makes metal liquid. A bar with a complete provenance file clears compliance in days and finances at better rates; a bar without one can sit in review for months. The paperwork is not overhead — it is the difference between inventory and an asset you can actually use.",
  },
  {
    q: "Can prices move against me during a transaction?",
    a: "Yes — commodity prices move constantly, and no structure removes market risk. What structure removes is everything else: counterparty failure, documentary disputes, custody gaps, settlement ambiguity. Price risk you manage; the rest, we engineer out.",
  },
];
